import $ from 'jquery';

export default function () {
	var curSlide = 1;

	$('#packaging-right').click(function () {
		if (curSlide === 1) {
			$('#packaging-slides').css('transform', 'translateX(-300px)');
			curSlide++;
		} else if (curSlide === 2) {
			$('#packaging-slides').css('transform', 'translateX(-600px)');
			curSlide++;
		} else if (curSlide === 3) {
			$('#packaging-slides').css('transform', 'translateX(-900px)');
			curSlide++;
		} else {
			$('#packaging-slides').css('transform', 'translateX(0)');
			curSlide = 1;
		}
	});

	$('#packaging-left').click(function () {
		if (curSlide === 4) {
			$('#packaging-slides').css('transform', 'translateX(-600px)');
			curSlide--;
		} else if (curSlide === 3) {
			$('#packaging-slides').css('transform', 'translateX(-300px)');
			curSlide--;
		} else if (curSlide === 2) {
			$('#packaging-slides').css('transform', 'translateX(0)');
			curSlide--;
		} else {
			$('#packaging-slides').css('transform', 'translateX(-900px)');
			curSlide = 4;
		}
	});
}
